import { OrganizationAuthMethodEnum } from 'src/api/main'
import { paths } from 'src/router'

import { SocialConnectCallbackPage } from './SocialConnectCallbackPage'

export const GoogleConnectCallback = () => (
  <SocialConnectCallbackPage
    provider={OrganizationAuthMethodEnum.GOOGLE}
    flow="clientConnect"
    redirectPath={paths.auth.googleClientConnectCallback}
    successMessageKey="profileAuthMethods.connectSuccess"
  />
)
